export * from './error-log'
export * from './countries'
export * from './chart-config'
export * from './typography'
export * from './colors'

import { ToastOptions, toast } from 'react-toastify'

export const toastOpts: ToastOptions = {
  position: 'bottom-left',
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'colored',
}

export const notify = {
  success: (msg: string) => toast.success(msg, toastOpts),
  error: (msg: string) => toast.error(msg, toastOpts),
}

export const validateEmail = (email: string) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
  return emailRegex.test(email)
}

export const isIcloudEmail = (email: string | null): boolean => {
  if (!email) return false
  return email.toLowerCase().endsWith('@icloud.com')
}

// Use Privy SDK user for identity/display info (emails, linked accounts)
import { User as PrivyUser } from '@privy-io/react-auth'

export const getEmailFromPrivyUser = (user: PrivyUser | null): string | null => {
  if (!user) return null

  // Prefer SDK top-level fields
  if (user.email?.address) return user.email.address
  const oauthEmail =
    user.google?.email ??
    user.discord?.email ??
    user.github?.email ??
    user.spotify?.email ??
    user.linkedin?.email ??
    user.apple?.email
  if (oauthEmail) return oauthEmail

  // Fallback to SDK linkedAccounts
  if (Array.isArray(user.linkedAccounts)) {
    const emailAccount = user.linkedAccounts.find((a) => a.type === 'email')
    if (emailAccount && emailAccount.type === 'email') return emailAccount.address

    for (const a of user.linkedAccounts) {
      const emailValue = (a as { email?: unknown }).email
      if (typeof emailValue === 'string') return emailValue
    }
  }

  // Final fallback for API snake_case payloads that might be stored
  const snake = (user as unknown as { linked_accounts?: unknown[] }).linked_accounts
  if (Array.isArray(snake)) {
    for (const acc of snake) {
      if (!acc || typeof acc !== 'object') continue
      const typeVal = (acc as { type?: unknown }).type
      if (typeVal === 'email') {
        const address = (acc as { address?: unknown }).address
        if (typeof address === 'string') return address
      }
      const email = (acc as { email?: unknown }).email
      if (typeof email === 'string') return email
    }
  }

  return null
}

export const getDisplayNameFromPrivyUser = (privyUser: PrivyUser | null): string => {
  const email = getEmailFromPrivyUser(privyUser)

  if (email) {
    // Extract first part of email for a friendlier display
    const name = email.split('@')[0]
    return name.charAt(0).toUpperCase() + name.slice(1)
  }

  return 'there'
}
